const $ = jQuery.noConflict();

class FileUploadInput {
    constructor() {
        this.inputs = 'input[type="file"]:visible';
    }

    init() {
        $(this.inputs).each((index, selectItem) => this.initInput(selectItem));

        $(document).bind('gform_post_render', () => {
            $(this.inputs).each((index, selectItem) => this.initInput(selectItem));
        });
    }

    initInput(input) {
        console.log(input.files);
        const files = this.getFilesText(input);
        $(input).before(`
            <div class="file-upload">
                <button class="file-upload__btn">Choose File</button>
                <p class="file-upload__files">${files}</p>
            </div>
        `);
        $(input).hide();

        this.bindEvents(input);
    }

    bindEvents(input) {
        $(input).prev().on('click', event => {
            $(input).trigger('click');
        });

        $(input).on('change', event => {
            const filesTextField = $(input).prev().find('.file-upload__files');
            filesTextField.text(this.getFilesText(input));
        });
    }

    getFilesText(input) {
        const prevFiles = $(input).parent().find('.ginput_preview');
        const files = input.files;
        if (files.length > 0) {
            const filesArray = [];
            Array.from(files).forEach(file => {
                filesArray.push(file.name);
            });
            return filesArray.join(', ');
        } else if (prevFiles.length) {
            return prevFiles.find('strong').text();
        } else {
            return 'No file chosen';
        }
    }
}

export default new FileUploadInput();